import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 2rem;
`

export const Title = styled.h2`
  font-size: 1.3rem;
  font-weight: 500;
`

export const List = styled.ul``

export const Item = styled.li`
  color: red;
  list-style-type: disclosure-closed;
`
